export default "__VITE_ASSET__DIKWqs_O__"